import SupportBanner from "~/components/analytics/suite/Setup/SupportBanner";

const ContentVitest = () => (
  <>
    <p>
      Before you start, make sure Vitest runs with access to{" "}
      <a
        className="purple"
        href="https://buildkite.com/docs/pipelines/configure/tests/test-collection/ci-environments"
      >
        CI environment variables
      </a>
      .
    </p>
    <p>Create a new branch:</p>

    <pre className="code">git checkout -b install-buildkite-test-analytics</pre>

    <p>
      Add the{" "}
      <a className="purple" href="https://www.npmjs.com/package/buildkite-test-collector">
        buildkite-test-collector package
      </a>{" "}
      to your dev dependencies:
    </p>

    <pre className="code">
      {[
        "# If you use npm:",
        "npm install --save-dev buildkite-test-collector",
        "",
        "# If you use Yarn:",
        "yarn add --dev buildkite-test-collector",
      ].join("\n")}
    </pre>

    <p>
      Update your{" "}
      <a className="purple" href="https://vitest.dev/config/">
        Vitest configuration
      </a>{" "}
      file (e.g. <code className="inline-block">vitest.config.js</code> or{" "}
      <code className="inline-block">vite.config.js</code>):
    </p>
    <pre className="code">
      {[
        "// vitest.config.js OR vite.config.js",
        "test: {",
        "  // Send results to Test Engine",
        "  reporters: [",
        "    'default',",
        "    'buildkite-test-collector/vitest/reporter'",
        "  ],",
        "  // Enable column + line capture for Test Engine",
        "  includeTaskLocation: true,",
        "}",
      ].join("\n")}
    </pre>

    <p>
      Add the <code className="inline-block">BUILDKITE_ANALYTICS_TOKEN</code> secret to your CI
      environment, push your changes to a branch, and open a pull request 🎉
    </p>
    <pre className="code">
      {["git add .", 'git commit -m "Install and set up Buildkite Test Engine"', "git push"].join(
        "\n",
      )}
    </pre>

    <p>
      <em>(Optional)</em> To pass in the API token using a custom environment variable, you can do
      so using the reporter options:
    </p>
    <pre className="code">
      {[
        "// vitest.config.js OR vite.config.js",
        "test: {",
        "  // Send results to Test Engine",
        "  reporters: [",
        "    'default',",
        "    ['buildkite-test-collector/vitest/reporter', {",
        "      token: process.env.CUSTOM_ENV_VAR",
        "    }]",
        "  ],",
        "}",
      ].join("\n")}
    </pre>

    <p>
      After completing these steps, you&apos;ll see the analytics of test executions on all branches
      that include this code in the Test Engine dashboard.
    </p>

    <SupportBanner />
  </>
);

export default ContentVitest;
